const pdpHelpers = require('./pdpHelpers');
const commonHelpers = require('../helpers/commonHelpers');
const recetaHelpers = require('./recetaHelpers');
const spamTxt = '.content-msj-text';
const repeatOrderFlowDefault = require('./repeatOrder')
const baseImported = require('./baseImportedFunctions');
const addToCartFunctions = require('./addToCart');
const RIGHT = 'Derecho';
const totalContainer =  $('.total-container-separator');

/**
 * @description - resets the RepeatOrder section if no products to be reorder are left
 */
function resetRepeatOrderSection() {
    $('.repeat-order-result-subscription').empty();
    $('.contacto-add-to-cart').removeClass('d-none');
    recetaHelpers.canBeAddedToCart();
}

/**
 * @description - it displays/hides the error section of the repeat Order RUT input
 * @param {string} msg - the message to be displayed
 * @param {boolean} show - determines if the message section should be displayed or hided
 */
function toggleError(msg, show) {
    $('.repeat-order-error-subscription.container-msj .content-msj span').html(msg);

    if(show) {
        $('.repeat-order-error-subscription.container-msj').addClass('error');
        $('#repeat-order-rut-subscription').addClass('invalid');
    } else {
        $('.repeat-order-error-subscription.container-msj').removeClass('error');
        $('#repeat-order-rut-subscription').removeClass('invalid');
    }
}

/**
 * @description - calcaultes the RepeatOrder subtotals
 */
function calculateSubtotals() {
    let totalSalesPrices = 0;
    let totalListPrice = 0;
    let discount = 0;

    $('.ordered-product').each(function(index, elem) {
        const quantity = $(elem).find('.line-item-quantity .ordered-product-quantity.custom-select').val();
        const listPrice = $(elem).data('main-product-base-price');
        const salesPrice = $(elem).data('main-product-price');

        totalSalesPrices += salesPrice ? (Number(salesPrice) * quantity) : 0;
        totalListPrice += listPrice ? (Number(listPrice) * quantity) : 0;
    });

    if(totalListPrice > 0 && totalSalesPrices > 0 && totalListPrice !== totalSalesPrices) {
        discount = totalListPrice - totalSalesPrices;
    }

    discount = Math.round(discount * 100) / 100;
    $('.subtotal-discount span').html(commonHelpers.formatMoneyToClp(discount));

    if(discount && discount > 0) {
        $('.subtotal-discount span').removeClass('d-none');
    } else {
        $('.subtotal-discount span').addClass('d-none');
    }

    totalSalesPrices = Math.round(totalSalesPrices * 100) / 100;
    $('.subtotal-amount span').html(commonHelpers.formatMoneyToClp(totalSalesPrices));
}

/**
 * @description - appendErrorMsj selection a container and paste a msj depending of the data attr
 * @param {string} container - container where be will paste the msj
 */
function appendErrorMsj(container) {
    let msjAssociateNotMatchRutGlobal = document.querySelector(`[${container}]`);
    if (msjAssociateNotMatchRutGlobal && msjAssociateNotMatchRutGlobal.getAttribute(container) === 'true') {
        let containerMsjGlobal = document.querySelector(`[${container}] ${spamTxt}`);
        containerMsjGlobal.innerHTML = msjAssociateNotMatchRutGlobal.getAttribute(`${container}-msj`);
    }
}

/**
 * @description - showNotifications show notifications or errors mjs.
 * @param {array} arrayMsj - arrayMsjglobals - arrays that contain the data attributes with the messages to display
 */
function showNotifications() {
    let products  = $('.ordered-product');
    let arrayMsj = [
        'data-product-associate-not-match-rut',
        'data-use-product-in-1-just-eye',
        'data-product-not-have-subscription',
        'data-just-one-eye-products-not-matches',
        'data-both-eyes-and-all-products-not-matches',
        'data-parameter-was-discontinued'
    ]
    let arrayMsjglobals = [
        'data-product-associate-not-match-rut-global',
        'data-parameter-was-discontinued',
        'data-product-not-have-subscription-global'
        
    ]
    
    let i = 0;
    for (i in arrayMsjglobals) {
        appendErrorMsj(arrayMsjglobals[i]);
    }

    if (products.length < 1) {
        $('.paste-elements-cloned-subscription button.add-repeated-products').prop('disabled', true);
    }

    Array.from(products).forEach(function(index, elem) {
        let key = 0;
        for (key in arrayMsj) {
            if (index.getAttribute(arrayMsj[key]) === 'true') {
                let productcontainer = index.getAttribute('data-id-position');
                let containerMsj = document.querySelector(`.repeat-order-error-product-${productcontainer} ${spamTxt}`);
                containerMsj.innerHTML = index.getAttribute(`${arrayMsj[key]}-msj`);
                $('.paste-elements-cloned-subscription button.add-repeated-products').prop('disabled', true);
            }
        }

    });
}

/**
 * @description - coppyAndPasteContainers Clone elements and replicate it in other container.
 */
function coppyAndPasteContainers() {
    $('.paste-elements-cloned-subscription').empty();
    $('.subscription-pdp form.ajaxRepiteReceta .repeated-order-totals').addClass('d-none');
    $('.subscription-pdp form.ajaxRepiteReceta .repeated-order-buttons').clone().appendTo('.paste-elements-cloned-subscription');
    $('.subscription-pdp form.ajaxRepiteReceta .repeated-order-buttons').addClass('d-none');
}

/**
 * @description - clickAutomatically the product which use in 1 just eye, for refresh the search in repeat order
 */
function clickAutomatically(products) {
    if (!products) {
        return;
    }

    Array.from(products).forEach(function(product, index) { 
       if (product.justOneEyeProductstMatches && !product.justOneEyeProductsNotMatches) {
            $(`[data-use-product-in-1-just-eye=true][data-sku=${product.id}]`).click();
            return;
       } 
    });
}

/**
 * @name generateDiopterInformationSubscription
 * @description - generate Diopter Information from receta data in repeat purchase Subscription feature
 * @param {array} return array diopter information
 */
function generateDiopterInformationSubscription(activeTabSelector) {
    let orderedProducts = $(activeTabSelector + ' .ordered-product');
    let dataRecetaContacto = {
        ojoDerecho : {},
        ojoIzquierdo: {}
    };
    
    orderedProducts.each(function(index, elem) {
       
        let eyeSide = elem.getAttribute('data-eye-side');
        let recipeSubscription = elem.getAttribute('data-recipeSubscription');
        let dataRecipeObj;
        try {
            dataRecipeObj = JSON.parse(recipeSubscription);
        } catch (error) {
            dataRecipeObj = {};
        }

        if (eyeSide === RIGHT) {
            dataRecetaContacto.ojoDerecho = dataRecipeObj && dataRecipeObj.ojoDerecho ? dataRecipeObj.ojoDerecho : {};
        } else {
            dataRecetaContacto.ojoIzquierdo = dataRecipeObj && dataRecipeObj.ojoIzquierdo ? dataRecipeObj.ojoIzquierdo : {};
        }
    });
    
    return dataRecetaContacto;
}

$('.repeat-order-result-subscription').on('click', '.ordered-product .remove-product', function (e) {
    const orderedProduct = $(e.currentTarget).parents('.ordered-product');
    const orderedProductPosition = $(orderedProduct).data('position');
    $('.subtotal-product[data-position="' + orderedProductPosition +'"]').remove();
    orderedProduct.remove();

    calculateSubtotals();

    if($('.ordered-product').length === 0) {
        resetRepeatOrderSection();
    }
});

$('#repeat-order-rut-subscription').on('keypress', function(event){    
    return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 75 || event.charCode === 107);
  });

$('.tabs-suscripcion .specify-diopter-section, .buy-one-pdp-content').on('show.bs.collapse', function (ev) {
    if ($('.paste-elements-cloned-subscription .repeated-order-buttons').length > 0) {
        $('.paste-elements-cloned-subscription .repeated-order-buttons').not('.cart-and-ipay').addClass('d-none');
        resetRepeatOrderSection();
        recetaHelpers.canBeAddedToCart();
      }
})

$(document).on('click', 'div.subscription-pdp .repeat-order-search-button', function (e) {
    e.preventDefault();
    const getLastOrderUrl = $('div.subscription-pdp').find('[data-url-get-last-order]').data('url-get-last-order');

    if(!getLastOrderUrl) {
        return false;
    }

    $('.repeat-order-result-subscription').empty();
    let repeatOrderRut = $('#repeat-order-rut-subscription').val();
    const regex = new RegExp($('#repeat-order-rut-subscription').prop('pattern'), "gi");

    if (!regex.test(repeatOrderRut)) {
        const msg = $('#repeat-order-rut-subscription').data('error-rut');
        toggleError(msg, true);
        return false;
    }

    if (!pdpHelpers.validateSubscriptionEyeSelection() || 
        !pdpHelpers.validateOnEyeEyeSelection() || 
        recetaHelpers.validationPlanSelects(false)) {
            return false;
    }

    toggleError('', false);

    repeatOrderRut = repeatOrderRut.slice(0, repeatOrderRut.length - 1) + '-' + repeatOrderRut.slice(repeatOrderRut.length - 1);

    $.spinner().start();

    const step1 = $('input:radio[name=step1]:checked');
    const step1dot1 = $("input:radio[name='step1.1']:checked");
    const useLeftEye = step1.val() === 'bothEyesPlans' || (step1dot1.is(':checked') && step1dot1.val() === recetaHelpers.LEFT_EYE )  ? 1 : 0;
    const useRightEye =  step1.val() === 'bothEyesPlans' || (step1dot1.is(':checked') && step1dot1.val() === recetaHelpers.RIGHT_EYE )  ? 1 : 0;

    $.ajax({
        url: getLastOrderUrl,
        method: 'GET',
        data: {repeatOrderRut: repeatOrderRut, currentProductId: $('.container.product-detail').data('pid'), useLeftEye: useLeftEye, useRightEye : useRightEye},
        success: function (response) {
            if(response.success) {
                $('.repeat-order-result-subscription').html(response.data);
                
                if($('.ordered-product').length > 0) {
                    $('.paste-elements-cloned-subscription button.add-repeated-products').prop('disabled', false);
                    $('.contacto-add-to-cart').addClass('d-none');
                    coppyAndPasteContainers();
                    showNotifications();
                    if (step1.val() === 'singleEyePlans') {
                        clickAutomatically(response.lastOrderData.products);
                    }
                }
                if (response.lastOrderData && response.lastOrderData.ParameterWasDiscontinued) {
                    $('.container-msj-was-discontinued').attr('data-parameter-was-discontinued',true);
                    showNotifications();
                } else {
                    $('.container-msj-was-discontinued').attr('data-parameter-was-discontinued',false);
                }
            } else {
                $('.repeat-order-error-subscription.container-msj').html(response.data);
                $('.repeat-order-error-subscription.container-msj').addClass('error');
                $('.repeat-order-input input').addClass('invalid');
            }

            $.spinner().stop();
        },
        error: function (err) {
            $('.repeat-order-buttons .add-repeated-products').prop('disabled', true);
            $.spinner().stop();
        }
    });
});

$(document).on('click', 'div.paste-elements-cloned-subscription  .add-repeated-products', function(e) {
    const addToCartUrl = baseImported.getAddToCartUrl();

    if(addToCartUrl) {
        const activeTabSelector = pdpHelpers.resolveActiveTabSelector();
        const productType = $('[data-tipo-producto]').val();
        const pid = baseImported.getPidValue($(this));
        const isCustomerAuthenticatedUrl = $('.backgroundCtn').data('is-customer-authenticate-url');
        const form = repeatOrderFlowDefault.methods.generateFormToAdd(pid, productType);
        if (pdpHelpers.isTabSuscriptionActive() &&
            $('#nav-subscription .step1 input[type="radio"]:checked').val() &&
            $('#subscriptionPlansSelect option').filter(':selected').val()) {
                form.selectedSubscriptionPlan = true;
                form.planId = $('#subscriptionPlansSelect option').filter(':selected').val();
                form.selectedQuantityEyes = $('#nav-subscription .step1 input[type="radio"]:checked').val();
                form.selectedEye = $('#nav-subscription .step1dot1 input[type="radio"]:checked').val();
                form.pidsObj = {};
                if (productType === 'lenteContacto') {        
                    let data = generateDiopterInformationSubscription(activeTabSelector);
                    form.dataRecetaContacto = JSON.stringify(data);
                }
                
        }
        
        if (!addToCartFunctions.validateCustomerAuthentication(isCustomerAuthenticatedUrl) && pdpHelpers.isTabSuscriptionActive()) {
            $('#subscription.backgroundCtn').toggleClass('d-none');
            document.cookie = 'dataCart='+ JSON.stringify(form) +'; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
            $.spinner().stop();
            return;
        }
        addToCartFunctions.addToCartSendData(addToCartUrl,form);
    }
});

$(document).on('click', '[data-use-product-in-1-just-eye="true"]', function() {
    const eyeSide = $(this).data('eye-side') === RIGHT ? 'right' : 'left';
    const selectPlan = $('#subscriptionPlansSelect');
    let planSelected = selectPlan.val();
    planSelected = planSelected.replace('BOTH_EYES', 'SINGLE_EYE')
    $('input:radio[name=step1][value=singleEyePlans]').click();
    $(`input:radio[name='step1.1'][value=${eyeSide}]`).click();
    selectPlan.val(planSelected);
    selectPlan.trigger('change');
    $(".subscription-pdp .repeat-order-search-button").click();
});

$('.subscription-pdp .repite-receta-button').on('click', function (e) {
    totalContainer.removeClass('d-none');
});

$('.subscription-pdp #repite-receta-accordion2-header').on('click', function (e) {
    totalContainer.addClass('d-none');
});